function tbwebsocket() {
	this.webSocket = null;
	this.webSocketUrl = null;
	// 私有function
	let onMessage;
	let onOpen;
	let onError;
	let onClose;
	let fiConnectNum;
	let limitConnectNum; //重新连接指定次数
	let self = this;
	this.init = function () {
		if (self.webSocketUrl == null || self.webSocketUrl == undefined || self.webSocketUrl == '') {
			alert("webSocketUrl undefied");
		}

		if ('WebSocket' in window) {
			self.webSocket = new WebSocket(self.webSocketUrl);
		}

		self.webSocket.onmessage = function (evnt) {
			limitConnectNum = fiConnectNum; //链接成功，重置可链接次数
			if (evnt.data.indexOf('{') == 0) {
				var jsonData = eval("(" + evnt.data + ")");
				onMessage(jsonData);
			} else {
				onMessage(evnt.data);
			}
		};
		self.webSocket.onopen = function (evnt) {
			if (onOpen) {
				onOpen(evnt);
			}
		};
		self.webSocket.onerror = function (evnt) {
			if (onError) {
				onError(evnt);
			}
		};
		self.webSocket.onclose = function (evnt) {
			if (onClose) {
				onClose(evnt);
			}
			limitConnectNum = limitConnectNum - 1;
			if (limitConnectNum >= 0) {

				self.layConntect(limitConnectNum);

			}
		};
	};
	this.layConntect = function () {
		setTimeout(this.init, 5000);
	}
	this.setMessageEvnt = function (messageEvnt) {
		onMessage = messageEvnt;
	};
	this.setOpenEvnt = function (openEvnt) {
		onOpen = openEvnt;
	};
	this.setOnerrorEvnt = function (errorEvnt) {
		onError = errorEvnt;
	};
	this.setOncloseEvnt = function (closeEvnt) {
		onClose = closeEvnt;
	};
	this.setLimitConnectNum = function (limitNum) {
		fiConnectNum = limitNum;
		limitConnectNum = fiConnectNum;
	}
}

export default tbwebsocket;